const hotel = {
  availableMealPlans: "Beschikbare maaltijdplannen", // translated
  availableRoomsTypes: "Beschikbare kamertypes", // translated
  cancellationPolicy: "Annuleringsvoorwaarden", // translated
  freeCancellationAvailable: "Gratis annuleren beschikbaar", // translated
  nonRefundable: "Geen terugbetaling mogelijk", // translated
  priceFor: "prijs voor", // translated
  nights: "nachten", // translated
  totalPrice: "Totale prijs", // translated
  seeAvailability: "Beschikbaarheid bekijken", // translated
  myProfile: "Mijn profiel", // translated
  travelTrust: "Reisvertrouwen", // translated
  signIn: "Inloggen", // translated
  searchNow: "Zoek nu", // translated
  policy: "Het beleid", // translated
  reservationDate: "Reserveringsdatum", // translated
  maxPax: "Max Pax", // translated
  room: "kamer", // translated
  cancellationRules: "Annuleringsregels", // translated
  hotelName: "Hotel naam", // translated
  beddingType: "Soort beddengoed", // translated
  cxlPolicy: "CXL-beleid", // translated
  cxlRules: "CXL-regels", // translated
};

export default hotel;
